<template>
  <section class="content">
    <admin-header
      :title="'Data Option Types'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminDataOptionType',
    data () {
      return {
        newEntityScreen: 'Admin - Data Option Types',
        searchEntityScreen: 'Admin - Data Option Type search',
        filterEventName: 'admin-data-option-type-filter',
        filterName: 'DataOptionTypeFilter'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminDataOptionType.vue?0a7b6732